// extracted by mini-css-extract-plugin
export default {"element":"style_element__pYRFc","image":"style_image__wur9j"};